module.exports = __webpack_public_path__ + "static/media/bg_login.acf3fb5e.jpg";